import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-store-v2-icon',
  templateUrl: './store-v2-icon.component.html',
})

export class StoreV2IconComponent {

}
